import type * as monaco from 'monaco-editor';

export const tsvTokenizer: monaco.languages.IMonarchLanguage = {
  tokenizer: {
    root: [
      [/^#fields.*$/, 'keyword'],
      // [/^#.*$/, 'comment'],
      [/\t+| {2,}/, 'delimiter'],
      // [/\b-?(?:0|[1-9]\d*)(?:\.\d+)?\b/, 'number'],
      [/[^\t\n]+/, 'string'],
    ],
  },
};
